export default "__VITE_ASSET__DjBoAUd3__"